<template>
  <div class="flex items-center">
    <div class="flex items-center" @click="handleClick">
      <span class="text-white/65 mr-2 text-[13px] font-[500]">{{ props.text }}</span>
      <Image
        :src="downArrowIcon"
        class="w-[12px] h-[6px] ml-2"
        :style="{ transform: 'rotate(-90deg)' }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import downArrowIcon from "./../images/downArrowIcon.png";

const props = defineProps({
  text: String,
});

const emit = defineEmits(["click"]);

const handleClick = () => {
  emit("click");
};
</script>
